import React from 'react';
import Hero from "./components/college-syllabus/Hero";
import Main from "./components/college-syllabus/Main";

const CollegeSyllabus = () => {
  return (
    <div>
        <Hero />
        <Main />
    </div>
  )
}

export default CollegeSyllabus;